import React from "react";

import { Divider } from "antd";

import { MidstreamNavigatorProvider } from "components/midstream/midstream-navigator/context/MidstreamNavigatorContext";

import FilterButton from "./FilterButtonFactory";
import "./MidstreamNavigatorToolbar.scss";
// import FilterButton, { FilterKey } from "./FilterButton";
import { FilterButtonProvider, FilterKey } from "./context/FilterButtonContext";

interface MidstreamNavigatorToolbarProps {
  topOffset?: number;
}

export const MidstreamNavigatorToolbar: React.FC<MidstreamNavigatorToolbarProps> = ({
  topOffset = 260
}) => {
  return (
    <MidstreamNavigatorProvider>
      <FilterButtonProvider>
        <div
          className="midstream-navigator-toolbar"
          style={{ top: `${topOffset}px` }}
          data-testid="midstream-navigator-toolbar">
          <div className="wrapper">
            <FilterButton filterKey={FilterKey.HighlightWells} />
            <FilterButton filterKey={FilterKey.FacilityAndWells} />
            <FilterButton filterKey={FilterKey.ContributingWellsFromAllFacilities} />
            <Divider />
            <FilterButton filterKey={FilterKey.WellNetwork} />
            <FilterButton filterKey={FilterKey.SalesFacilities} />
          </div>
        </div>
      </FilterButtonProvider>
    </MidstreamNavigatorProvider>
  );
};
